import React from 'react';
import PropTypes from 'prop-types';
import axiosInstance from '../../../services/api';
import fileDownload from 'js-file-download';
import { withRouter } from 'react-router-dom';

class DownloadVouchers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const id = this.props.match.params.registrationId;
    axiosInstance({
      method: 'get',
      url: `${baseUrl}registrations/${id}/download-vouchers`,
      responseType: 'blob'
    }).then(response => {
      fileDownload(response.data, 'vouchers.zip');
      this.props.history.push('/');
    });
  }

  render() {
    return <div>Download Starting...</div>;
  }
}

export default withRouter(DownloadVouchers);
